import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import { useMeta } from './hooks/useMeta';

function Mimadre() {
  useMeta({
    title: 'Mimadre - Inmaculada Fuentes',
    description: 'Mimadre: Un libro infantil que narra la vida desde la perspectiva de una niña. Álbum ilustrado solidario y educativo por Inmaculada Fuentes.',
    image: '/portada_mimadre.avif',
    url: 'https://inmaculadafuentes.com/mimadre'
  });

  return (
    <div className="app">
      <Navbar showHomeLink />

      {/* Book Content */}
      <section className="book-page">
        <div className="book-hero">
          <img src="portada_mimadre.avif" alt="Portada Mimadre" className="book-hero-cover" />
          <h1>Mimadre</h1>
          <p>Un disco infantil que narra la vida desde la perspectiva de una niña.</p>
        </div>

        <div className="book-section">
          <h2>Lo que dicen de Mimadre</h2>
          
          <div className="quote">
            <p>"Este libro es tan sencillo como puedas imaginar y tan profundo como puedas sentir. Inma Fuentes ha conseguido con él, sin trucos ni artificios, entrar y penetrar en el corazón del lector."</p>
            <div className="quote-author">
              <strong>José Luis Ferris</strong><br />
              Escritor
            </div>
          </div>

          <div className="quote">
            <p>"Un canto a la libertad de ser una misma. Una historia que pondera a las madres viajeras y valientes, aquellas que rompen barreras, las luchadoras e independientes. El texto y las ilustraciones hacen de este un libro precioso."</p>
            <div className="quote-author">
              <strong>Margarita del Mazo</strong><br />
              Escritora y narradora
            </div>
          </div>

          <div className="quote">
            <p>"Conmovedor, directo y poderoso. Una lucha contra el tiempo, en el que gana quien tiene que ganar, el amor."</p>
            <div className="quote-author">
              <strong>Espido Freire</strong><br />
              Escritora
            </div>
          </div>
        </div>

        <div className="book-section">
          <h2>Información del libro</h2>
          <div className="book-info">
            <p><strong>Idea original, texto y edición:</strong> Inmaculada Fuentes Tomás</p>
            <p><strong>Ilustración:</strong> Sandra Prim</p>
            <p><strong>Edita:</strong> Mimadre Universe</p>
            <p><strong>ISBN:</strong> 978-84-09-27966-1</p>
            <p><strong>Tamaño:</strong> 25x25 cm</p>
            <p><strong>Páginas:</strong> 24</p>
            <p><strong>Características:</strong> Ilustrado a todo color, tapa dura</p>
            <p><strong>Papel:</strong> Pura celulosa ecológica ECF. Certificados FSC</p>
            <p><strong>Impresión:</strong> España - Printed in Spain</p>
            <p><strong>Otros idiomas:</strong> Valencià Mamare (ISBN 978-84-09-30287-1)</p>
            <p><strong>Año:</strong> 2021</p>
            <p><strong>Características especiales:</strong> Libro solidario</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Mimadre;